import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { openLinkagesById } from '../../../../scenes/Gnosus/scenes/Linkages/actions'

export function mapDispatchToProps(dispatch) {
    return bindActionCreators({ openLinkagesById }, dispatch)
}

export default function (InnerComponent) {
    @connect(null, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
